export default __webpack_public_path__ + "static/media/intensive-learning.169d9cc7.svg";